import { color, spacing, media } from "@universityofmaryland/web-token-library";
import "../../typography/font-face/index.js";
import "../../typography/campaign.js";
import { labelSmall } from "../../typography/elements.js";
import "../../typography/sans.js";
import "../../typography/serif.js";
import "../../typography/stats.js";
import { objectWithClassName } from "../../utilities/create/jss.js";
import "../../node_modules/.pnpm/postcss@8.5.8/node_modules/postcss/lib/postcss.js";
import "../../node_modules/.pnpm/postcss-js@4.1.0_postcss@8.5.8/node_modules/postcss-js/index.js";
import "../../node_modules/.pnpm/postcss-nesting@13.0.2_postcss@8.5.8/node_modules/postcss-nesting/dist/index.js";
import "../../_virtual/index.js";
const classNamePrefix = "umd-text-line";
const trailingBefore = {
  content: '""',
  position: "absolute",
  top: "9px",
  right: `0`,
  width: `100vw`,
  height: "1px",
  background: `${color.black}`,
  zIndex: 1
};
function composeTrailing(options) {
  const { theme = "default" } = options || {};
  let composed = {
    ...labelSmall,
    textTransform: "uppercase",
    position: "relative",
    overflow: "hidden",
    "&::before": {
      ...trailingBefore
    },
    "& > span": {
      position: "relative",
      backgroundColor: `inherit`,
      paddingRight: spacing.min,
      zIndex: 2
    },
    "& + *": {
      marginTop: spacing.xl
    }
  };
  if (theme === "default") {
    composed = {
      ...composed,
      backgroundColor: `${color.white}`
    };
  } else if (theme === "light") {
    composed = {
      ...composed,
      backgroundColor: `${color.gray.lighter}`
    };
  } else if (theme === "dark") {
    composed = {
      ...composed,
      backgroundColor: `${color.gray.darker}`,
      color: `${color.white}`,
      "&::before": {
        ...trailingBefore,
        background: `${color.white}`
      }
    };
  }
  let className = `${classNamePrefix}-trailing`;
  const deprecatedAliases = [];
  if (theme === "light") {
    className = `${classNamePrefix}-trailing-light`;
    deprecatedAliases.push('umd-tailwing-right-headline[theme="light"]');
  } else if (theme === "dark") {
    className = `${classNamePrefix}-trailing-dark`;
    deprecatedAliases.push('umd-tailwing-right-headline[theme="dark"]');
  } else {
    deprecatedAliases.push("umd-tailwing-right-headline");
  }
  return objectWithClassName({
    ...composed,
    className: deprecatedAliases.length > 0 ? [className, ...deprecatedAliases] : className
  });
}
function composeAdjacent(options) {
  const { inset = false } = options || {};
  let composed = {
    position: "relative",
    "&::before": {
      content: '""',
      display: "block",
      position: "absolute",
      top: 0,
      width: "2px",
      height: "100%",
      backgroundColor: color.red
    }
  };
  if (inset) {
    composed = {
      ...composed,
      paddingLeft: `${spacing.md}`,
      "&::before": {
        ...composed["&::before"],
        left: 0
      }
    };
  } else {
    composed = {
      ...composed,
      "&::before": {
        ...composed["&::before"],
        left: `-${spacing.md}`
      }
    };
  }
  const className = inset ? `${classNamePrefix}-adjustent-inset` : `${classNamePrefix}-adjustent`;
  const deprecatedAliases = inset ? [] : ["umd-adjacent-line-text"];
  return objectWithClassName({
    ...composed,
    className: deprecatedAliases.length > 0 ? [className, ...deprecatedAliases] : className
  });
}
const tailwing = objectWithClassName({
  className: [
    `${classNamePrefix}-tailwing`,
    /** @deprecated Use 'umd-text-line-tailwing' instead */
    "umd-tailwings-headline"
  ],
  ...labelSmall,
  textAlign: "center",
  textTransform: "uppercase",
  overflow: "hidden",
  position: "relative",
  "&::before": {
    content: '""',
    position: "absolute",
    top: "9px",
    left: `0`,
    width: `100vw`,
    height: "1px",
    background: `${color.black}`,
    zIndex: -1
  },
  "& > span": {
    position: "relative",
    display: "inline-block",
    maxWidth: "70%",
    "&::after": {
      content: '""',
      position: "absolute",
      top: "0",
      left: `-2px`,
      right: `-2px`,
      height: "100%",
      backgroundColor: `${color.white}`,
      zIndex: -1,
      [`@media (${media.queries.medium.min})`]: {
        left: `-${spacing.min}`,
        right: `-${spacing.min}`
      },
      [`@media (${media.queries.large.min})`]: {
        left: `-${spacing.sm}`,
        right: `-${spacing.sm}`
      }
    }
  },
  "& + *": {
    marginTop: spacing.md
  }
});
const trailing = composeTrailing();
const trailingLight = composeTrailing({ theme: "light" });
const trailingDark = composeTrailing({ theme: "dark" });
const adjustent = composeAdjacent();
const adjustentInset = composeAdjacent({ inset: true });
export {
  adjustent,
  adjustentInset,
  composeAdjacent,
  composeTrailing,
  tailwing,
  trailing,
  trailingDark,
  trailingLight
};
//# sourceMappingURL=line.js.map
